import { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";

const ScrollingBanner = () => {
    const [bannerText, setBannerText] = useState(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const fetchBannerText = async () => {
            try {
                const response = await axiosInstance.get("/application-configuration");
                const headerBannerText = response.data.header_banner_text;
                if (headerBannerText) {
                    setVisible(true);
                    setBannerText(headerBannerText);
                }
            } catch (error) {
                console.error("Failed to fetch banner text", error);
            }
        };
        fetchBannerText();
    }, []);

    if (!visible) return null;

    return (
        <div className="relative z-10 flex h-11 items-center overflow-hidden bg-gradient-to-r from-red-600 via-orange-500 to-red-600">
            <div className="animate-scroll whitespace-nowrap px-4 text-sm font-semibold text-white hover:[animation-play-state:paused] sm:px-6">
                {bannerText}
            </div>
            <button
                onClick={() => setVisible(false)}
                className="absolute right-2 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-white/80 transition hover:bg-black/20 hover:text-white sm:right-4"
                aria-label="Close Banner"
            >
                ×
            </button>
        </div>
    );
};

export default ScrollingBanner;
